import { styled } from '@mui/material/styles';

export const ScrollContainer = styled('div')(({ theme }) => ({
  '*::-webkit-scrollbar': {
    width: '0.1rem',
    height: '0.1rem',
    backgroundColor: 'transparent',
  },
  '*::-webkit-scrollbar-thumb': {
    backgroundColor: theme.colors.base04,
  },
  '*::-webkit-scrollbar-corner': {
    backgroundColor: 'transparent',
  },
}));

export const Container = styled('div')(({ theme }) => ({
  height: '7rem',

  fontSize: theme.typography.h9.fontSize,
  fontFamily: theme.typography.h9.fontFamily,

  '& a': {
    textDecoration: 'none',
    color: theme.colors.accentBlue,
    '&:hover': {
      opacity: 0.8,
    },
  },

  overflow: 'auto',
}));
